module.exports = __webpack_public_path__ + "static/img/about_bg.9c29f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_bg.png
// module id = H7on
// module chunks = 1